import { defineStore } from 'pinia'

export type ErrorModalType = 'ymm' | 'vin' | 'lp'
export type InfoModalType = 'phone' | 'message'
export type DialogState = {
	vehicleOpen: boolean
	confirmationModal: {
		open: boolean
		title: string
		subtitle: string
		confirmButton: string
		cancelButton: string
		action: () => Promise<any>
		resolve: (v: unknown) => void
		reject: () => void
	}
	errorModal: {
		open: boolean
		type: ErrorModalType
		title: string
		subtitle: string
		isOld: boolean
	}
	mileageErrorData: {
		isModalOpen: boolean
		wasModalOpen: boolean
		mileage: number
		years: number
		isTooMuch: boolean
	}
	infoModal: {
		open: boolean
		type: string
		sellerData?: {
			name: string
			phone: string
			email: string
		}
	}
	simpleModalOpen: boolean
	headerFormModalOpen: boolean
	headerFormModalError: boolean
	trimsModalOpen: boolean
}

export const useDialogStore = defineStore({
	id: 'dialogStore',
	state: () =>
		({
			vehicleOpen: false,
			confirmationModal: {
				open: false,
				title: '',
				subtitle: '',
				confirmButton: 'Yes',
				cancelButton: 'No',
			},
			errorModal: {
				open: false,
				type: 'ymm',
				title: '',
				subtitle: '',
				isOld: false,
			},
			mileageErrorData: {
				isModalOpen: false,
				wasModalOpen: false,
				mileage: 0,
				years: 0,
				isTooMuch: false,
			},
			infoModal: {
				open: false,
				type: '',
				sellerData: {
					name: '',
					phone: '',
					email: '',
				},
			},
			simpleModalOpen: false,
			headerFormModalOpen: false,
			headerFormModalError: false,
			trimsModalOpen: false,
		} as DialogState),

	getters: {},

	actions: {
		openConfirmationModal({
			title,
			subtitle = '',
			confirmButton = 'Yes',
			cancelButton = 'Cancel',
			action,
		}: {
			title: string
			subtitle?: string
			confirmButton?: string
			cancelButton?: string
			action: () => Promise<any>
		}) {
			return new Promise((resolve, reject) => {
				this.confirmationModal.title = title
				this.confirmationModal.subtitle = subtitle
				this.confirmationModal.confirmButton = confirmButton
				this.confirmationModal.cancelButton = cancelButton
				this.confirmationModal.action = action
				this.confirmationModal.resolve = resolve
				this.confirmationModal.reject = reject

				this.confirmationModal.open = true
			})
		},

		openErrorModal({
			type,
			title,
			subtitle,
			isOld = false,
			open = true,
		}: {
			type: ErrorModalType
			title: string
			subtitle: string
			isOld?: boolean
			open?: boolean
		}) {
			this.errorModal.type = type
			this.errorModal.title = title
			this.errorModal.subtitle = subtitle
			this.errorModal.isOld = isOld
			this.errorModal.open = open
		},

		closeErrorModal() {
			this.errorModal.open = false
		},

		openInfoModal({
			type,
			seller,
		}: {
			type: string
			seller: { name: string; phone: string; email: string }
		}) {
			this.infoModal.type = type
			if (seller) {
				this.infoModal.sellerData = seller
			}
			this.infoModal.open = true
		},

		closeInfoModal() {
			this.infoModal.open = false
		},

		openSimpleModal() {
			this.simpleModalOpen = true
		},

		closeSimpleModal() {
			this.simpleModalOpen = false
		},

		openHeaderFormModal() {
			this.headerFormModalOpen = true
		},

		closeHeaderFormModal() {
			this.headerFormModalOpen = false
		},
		openTrimsModal() {
			this.trimsModalOpen = true
		},

		closeTrimsModal() {
			this.trimsModalOpen = false
		},
		toggleFormModalError(isError: boolean) {
			this.headerFormModalError = isError
		},
	},
})
